export const templates = [
  {
    id: "pro-services",
    previewHeight: 652,
    title: "Studio Professionale",
    subtitle: "Contabili - Assicuratori - Consulenti",
    blurb:
      "Hero con headline di valore, blocco servizi a tre colonne e CTA 'Prenota una consulenza'. Include sezione testimonianze e pacchetti tariffari.",
    highlights: ["Palette blu profondo", "Timeline certificazioni", "Modulo contatto sticky"],
  },
  {
    id: "craftsmen",
    previewHeight: 652,
    title: "Artigiani & Professionisti di settore",
    subtitle: "Falegnami - Idraulici - Designer",
    blurb:
      "Layout modulare con ampie foto prima/dopo, lista interventi rapidi e badge di disponibilita immediata. Perfetto per raccontare manualita e fiducia.",
    highlights: ["Hero immersivo", "Slider lavori recenti", "Sezione 'Come lavoro'"],
  },
  {
    id: "nonprofit",
    previewHeight: 628,
    title: "Associazioni",
    subtitle: "ETS - Onlus - No profit",
    blurb:
      "Struttura narrativa: manifesto, impatto numerico, storie delle persone e call to action donazione/eventi. Integra calendario rapido e form adesioni.",
    highlights: ["Counter impatto", "Story cards", "CTA doppia Donazione / Diventa volontario"],
  },
  {
    id: "sme",
    previewHeight: 641,
    title: "PMI & Startup",
    subtitle: "Prodotti digitali e servizi B2B",
    blurb:
      "Landing modulare orientata alla conversione: value proposition, blocco feature, social proof e pricing plan. Ideale per aziende innovative.",
    highlights: ["Hero split con mockup", "Loghi clienti", "FAQ accordion"],
  },
  {
    id: "retail",
    previewHeight: 629,
    title: "Negozi & Attivita commerciali",
    subtitle: "Local shop - Boutique - Food",
    blurb:
      "Template one-page con menu rapido, galleria prodotti e sezione orari/posizione. Focus su prenotazione veloce e integrazione mappe.",
    highlights: ["Cards prodotti", "Banner promo", "Mappa interattiva"],
  },
];

